import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { i18nUserContext } from "config/translations/I18n";
import { GlobalState } from "store/configure-store";
import {
  selectCorrelationId,
  selectNotificationMessage,
} from "store/reducers/notification.reducer";
import {
  NotificationTypeEnum,
  translateKey,
} from "common/enums/NotificationTypeEnum";
import { Alert, Modal } from "@cc/react-components";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  show: boolean;
  setShow: (isModalOpen: boolean) => void;
  notificationType: NotificationTypeEnum;
}

interface StateToProps {
  notificationMessage?: string;
  correlationId?: string;
}

const NotificationModal = ({
  show,
  setShow,
  notificationType,
  notificationMessage,
  correlationId,
}: StateToProps & Props) => {
  const [t] = useTranslation("", { i18n: i18nUserContext });

  if (show) {
    return (
      <Modal show onHide={() => setShow(false)} centered>
        <Alert
          className="m-0"
          variant={getVariant(notificationType)}
          onClose={() => setShow(false)}
          dismissible
        >
          <Alert.Heading>
            {t(translateKey(NotificationTypeEnum[notificationType]))}
          </Alert.Heading>
          <p className="text-wrap text-break">{notificationMessage}</p>
          <small>{correlationId && t("error.uniqueId") + correlationId}</small>
        </Alert>
      </Modal>
    );
  }
  return null;
};

const getVariant = (type: NotificationTypeEnum) => {
  if (type === NotificationTypeEnum.ERROR) {
    return "danger";
  } else if (type === NotificationTypeEnum.WARNING) {
    return "warning";
  } else {
    return "info";
  }
};

const mapStateToProps = (state: GlobalState) => {
  return {
    notificationMessage: selectNotificationMessage(state),
    correlationId: selectCorrelationId(state),
  };
};

export default connect(mapStateToProps)(NotificationModal);
